"use client";

import { Award, BadgeCheck, ShieldCheck, Star, Wrench, Zap } from "lucide-react";
import { Card } from "@/components/ui/card";
export default function Protection() {
  const certifications = [];
  const tickerItems = ["FULLY INSURED & BONDED", "PROFESSIONAL ROOF CARE", "GUTTER REPAIR EXPERTS", "COMMERCIAL & DOMESTIC", "FULLY INSURED & BONDED", "PROFESSIONAL ROOF CARE", "GUTTER REPAIR EXPERTS", "COMMERCIAL & DOMESTIC"];
  return <section data-section-id="1876" id="certified-protection" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28">
      {}
      <div className="absolute top-0 left-0 right-0 border-b border-border bg-card overflow-hidden">
        <div className="flex whitespace-nowrap py-3 animate-[ticker_40s_linear_infinite]">
          {[...tickerItems, ...tickerItems].map((item, i) => <div data-index={i} key={i} className="flex items-center font-mono text-xs tracking-[0.18em] uppercase text-primary px-6 shrink-0">
              <span className="mr-6 text-primary">·</span>
              <span>{item}</span>
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes highlightSwipe {
          0% { transform: scaleX(0); }
          100% { transform: scaleX(1); }
        }
      `}</style>

      <div className="relative max-w-[1360px] mx-auto px-6 md:px-10 lg:px-16 pt-12 md:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          {}
          <div className="lg:col-span-4">
            {}
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-2.5 h-2.5 bg-primary rounded-lg" />
              <span className="font-mono text-xs md:text-sm tracking-[0.18em] uppercase font-medium text-muted-foreground">
                ROOFPRO / STANDARDS
              </span>
            </div>

            {}
            <h2 className="font-default font-black uppercase text-foreground leading-[0.95] tracking-[-0.015em] mb-6" style={{
            fontSize: "clamp(2rem, 4.5vw, 4.25rem)"
          }}>
              <span className="relative inline-block">
                <span className="absolute inset-x-[-0.1em] inset-y-[0.1em] bg-primary origin-left" style={{
                animation: "highlightSwipe 500ms cubic-bezier(0.2, 0.7, 0.2, 1) forwards"
              }} aria-hidden="true" />
                <span className="relative text-chart-2">QUALITY</span>
              </span>
              ,
              <br />
              NOT COMPROMISE.
            </h2>

            {}
            <div className="h-3 w-32 mb-6" style={{
            background: "repeating-linear-gradient(135deg, hsl(48 95% 50%) 0 8px, hsl(220 20% 4%) 8px 16px)"
          }} />

            {}
            <p className="font-default text-base md:text-lg leading-[1.55] text-muted-foreground max-w-md">
              Every project we undertake is backed by rigorous safety protocols and industry-leading expertise. We don't just clean roofs — we restore structural integrity and ensure long-term protection for your property.
            </p>

            <div className="mt-8 pt-6 border-t border-border">
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground">
                ROOFPRO / EXTERIOR RESTORATION
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-8 relative">
            {}
            <div aria-hidden="true" className="absolute -top-8 -right-4 pointer-events-none select-none font-default font-black text-foreground opacity-[0.06] leading-none" style={{
            fontSize: "clamp(16rem, 24vw, 28rem)",
            transform: "rotate(-2deg)",
            zIndex: 0
          }}>
              09
            </div>

            <div className="relative grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {certifications.map((cert, i) => {
              const Icon = cert.icon;
              return <Card data-index={i} key={cert.name} className="group relative bg-card border border-border rounded-md aspect-square p-4 md:p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200">
                    {}
                    <span aria-hidden="true" className="absolute top-0 left-0 w-2 h-2 border-t border-l border-primary transition-all duration-[240ms] ease-out group-hover:-top-1.5 group-hover:-left-1.5" />
                    <span aria-hidden="true" className="absolute top-0 right-0 w-2 h-2 border-t border-r border-primary transition-all duration-[240ms] ease-out group-hover:-top-1.5 group-hover:-right-1.5" />
                    <span aria-hidden="true" className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-primary transition-all duration-[240ms] ease-out group-hover:-bottom-1.5 group-hover:-left-1.5" />
                    <span aria-hidden="true" className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-primary transition-all duration-[240ms] ease-out group-hover:-bottom-1.5 group-hover:-right-1.5" />

                    {}
                    <div className="flex items-center gap-1.5">
                      <Icon className="size-8 md:size-10 text-foreground transition-colors duration-200 group-hover:text-primary" strokeWidth={1.75} />
                      <span className="w-1.5 h-1.5 bg-primary rounded-lg shrink-0" />
                    </div>

                    {}
                    <div className="text-center w-full">
                      <div className="font-default font-bold uppercase text-[10px] md:text-xs leading-tight text-foreground tracking-tight mb-1.5">
                        {cert.name}
                      </div>
                      <div className="font-mono text-[9px] md:text-[10px] tracking-[0.08em] uppercase text-muted-foreground leading-tight">
                        {cert.credential}
                      </div>
                    </div>
                  </Card>;
            })}
            </div>

            {}
            <div className="relative mt-8 flex items-center justify-between border-t border-border pt-4">
              <span className="font-mono text-[10px] md:text-xs tracking-[0.18em] uppercase text-muted-foreground">
                06 OF 06 STANDARDS ACTIVE
              </span>
              <span className="font-mono text-[10px] md:text-xs tracking-[0.18em] uppercase text-primary">
                VERIFIED 2025
              </span>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-3" style={{
      background: "repeating-linear-gradient(135deg, hsl(48 95% 50%) 0 12px, hsl(220 20% 4%) 12px 24px)"
    }} aria-hidden="true" />
    </section>;
}